export default __webpack_public_path__ + "07d82f38f7f0cecd25125488f8103cc6.svg";